import {useCallback, useState} from "react";
import {HttpMethod, initFetch} from "../utils/fetcher";

const initialState = {advance:[], number:0, entries: null};

const useAdvancedOwner = () => {

  const [data, setData] = useState(initialState);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const storeAdvance = useCallback( async (data) => {

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const { url, params} = initFetch('advanced-owner', HttpMethod.POST);
      const response = await fetch(url, {
        ...params,
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }

      const result = await response.json();

      // a remettre lorsque status
      /*if (!result.status) {
        throw new Error(`Erreur returned ${response.message}`);
      }*/

      setSuccess(true);
      return result;
      //setData({...initialState, entries: result})

    }
    catch (e) {
      setError(e.message);
      throw e;
    }
    finally {
      setLoading(false);
    }
  }, []);

  const fetchAdvance = useCallback(async (date) => {

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const { url, params} = initFetch(`advanced-owner?date=${date}`, HttpMethod.GET);
      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(`Erreur returned ${response.message}`);
      }

      result.advance = result.advance.map(obj => ({
        ...obj,
        amount: 0.00
      }));

      setData({
        advance: result.advance,
        number: result.number,
      });

      //console.log(result);

    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
      setSuccess(true);
    }

  },[]);

  const clearAdvance = useCallback(() => {
    setData(initialState);
  }, []);

  return {
    // Données
    data,

    // États
    loading,
    error,
    success,

    // Actions
    fetchAdvance,
    storeAdvance,
    clearAdvance,
  };

};

export default useAdvancedOwner;